import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';

const beSetupStylistStripeAccount = actionBe(
  'beSetupStylistStripeAccount',
  withOptions(({ AT, ATAG, stylistId, transferPolicy }) =>
    endpoint(H.post, 'payments/stripe/setup/stylist/account/:salonId/:stylistId/', {
      AT,
      name: ATAG,
      params: { stylistId },
      data: { transfer_policy: transferPolicy },
    }),
  ),
);

// noinspection JSUnusedGlobalSymbols
export default beSetupStylistStripeAccount;
